import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
let BaseTextField = class BaseTextField extends Vue {
    styles() {
        return {
            'pt-0': this.pt0,
        };
    }
};
__decorate([
    Prop({ type: String, default: '' })
], BaseTextField.prototype, "label", void 0);
__decorate([
    Prop({ type: String, default: 'Type here' })
], BaseTextField.prototype, "placeholder", void 0);
__decorate([
    Prop({ type: String, default: 'black' })
], BaseTextField.prototype, "color", void 0);
__decorate([
    Prop({ type: String, default: '' })
], BaseTextField.prototype, "value", void 0);
__decorate([
    Prop({ type: Array, default: () => [] })
], BaseTextField.prototype, "errorMessages", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseTextField.prototype, "disabled", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseTextField.prototype, "readonly", void 0);
__decorate([
    Prop({ type: String, default: null })
], BaseTextField.prototype, "hint", void 0);
__decorate([
    Prop({ type: String, default: undefined })
], BaseTextField.prototype, "mask", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseTextField.prototype, "password", void 0);
__decorate([
    Prop({ type: String, default: undefined })
], BaseTextField.prototype, "autocomplete", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseTextField.prototype, "pt0", void 0);
__decorate([
    Prop({ type: Boolean, default: false })
], BaseTextField.prototype, "persistentHint", void 0);
__decorate([
    Prop({ type: String, default: undefined })
], BaseTextField.prototype, "dataCy", void 0);
BaseTextField = __decorate([
    Component
], BaseTextField);
export default BaseTextField;
